<template lang="pug">
div
  Loader(
    :loading="loading",
    :message="loaderMessage",
    :retry="loadeRetry",
    @load-retry="loadRetry"
  )
  .product
    .product-top
      .product-info.is-flex-desktop.columns
        .column.is-3.has-text-left
          template(v-if="zones")
            div(v-for="(zone, k) of zones", :key="k")
              h1.title(style="margin-top: 1.5rem" v-if="!zone.preOrder") {{ zone.provider_name }}
              h1.title(style="margin-top: 1.5rem" v-else) {{ zone.provider_name + " Pre-Order" }}
              .product-type.has-text-left.is-capitalized
                label.product-type-option(data-name="All")
                  input(
                    type="radio",
                    name="typed",
                    :value="`${zone.provider_name}=null`",
                    :checked="productSection == `${zone.provider_name}=null`",
                    @change="$store.commit('setProductSection', `${zone.provider_name}=null`); setFirstSelectedProduct()"
                  )
                  span.product-type-label All
                label.product-type-option(
                  v-for="(v, k) in zone.promoCodes",
                  :key="k",
                  :data-name="v.code"
                )
                  input(
                    type="radio",
                    name="typed",
                    :value="`${zone.provider_name}=${k}`",
                    :checked="productSection == `${zone.provider_name}=${k}`",
                    @change="$store.commit('setProductSection', `${zone.provider_name}=${k}`); setFirstSelectedProduct()"
                  )
                  span.product-type-label {{ v.description }}

        .column.is-6
          .product-details.box.has-text-left
            h2.subtitle.product-address-title {{ buildAddressWithName }}
            h2.title Select Package:
            .columns(v-if="productType != 'data-only'")
              .column.is-4
                .input-group
                  .control.radio-control
                    label.radio
                      input(
                        type="radio",
                        name="installType",
                        value="new",
                        @click="setInstallType('new')",
                        :checked="installType === 'new'",
                        style="margin-right: 5px"
                      )
                      span.radio-checkmark
                        | New Installation
              .column.is-4
                .input-group
                  .control.radio-control
                    label.radio
                      input(
                        type="radio",
                        name="installType",
                        value="existing",
                        @click="setInstallType('existing')",
                        :checked="installType === 'existing'",
                        style="margin-right: 5px"
                      )
                      span.radio-checkmark
                        | Move from another ISP/ reactivate a dormant installation
              .column.is-4
               .input-group
                 .control.radio-control
                   label.radio
                     input(
                       type="radio",
                       name="installType",
                       value="upgrade",
                       @click="setInstallType('upgrade')",
                       :checked="installType === 'upgrade'",
                       style="margin-right: 5px"
                     )
                     span.radio-checkmark
                       | Upgrade/ Downgrade

            v-select(:options="activeProductsForRender" label="name" value="promocodeproductid" :clearable="false"
              :searchable="false" v-model="selectedProductFull" @input="productSelected()")
            template(v-if="selectedProduct")
              h1.title(style="margin-bottom: 0") {{ get(activeProducts, ["#"+selectedProduct, 'monthly']) == '0.00' ? 'FREE' : 'R ' + get(activeProducts, ["#"+selectedProduct, 'monthly']) }}
              div VAT incl. per month
            .product-details-buttons
              button.button.is-primary.is-fullwidth.product-details-button(
                @click.prevent="showModal = true",
                :disabled="selectedProduct === null"
              ) GET THIS
              router-link.button.is-fullwidth.product-details-button(
                :to="{ path: $route.fullPath + '/all', query: { lat: coordsFromMap.lat, lng: coordsFromMap.lng } }"
              ) SHOW ALL PRODUCTS
            p.has-text-weight-normal(
              style="margin: 2rem 0",
              v-if="productDescription"
            ) {{ productDescription }}
            p
              a.info-link(@click.prevent="showDetails = true") Full product details
            //- p.product-details-install-time
            //-   | Approximately 6 months from date of order
            //-   span.icon.time-info(tabindex="-2")
            //-     fa-icon(icon="question-circle")
            //-     .popover-info
            //-       .arrow
            //-       .text Your location requires a third part service provider to come to your property and connect your little grey box to your router. Waiting periods are typically 2 weeks but try our best to get you connected at lightspeed.
            img.product-details-image-ad(src="/img/COMBO-Logo-Black.svg", v-if="showLightspeedLogo")

          CustomInput(
            type="text",
            disabled,
            v-model="buildAddressWithName",
            style="margin-top: 0.75rem"
          )

          img.product-user-location-map.is-hidden-mobile(
            @error="mapLoadError()",
            v-if="builtAddress",
            :src="`https://maps.googleapis.com/maps/api/staticmap?&markers=${coordsFromMap.lat + ',' + coordsFromMap.lng}${mapPathString}&zoom=${mapsZoom['big']}&size=640x360&maptype=roadmap&key=${mapsKey}`"
          )

          a(
            @click="$router.push({ name: 'home' })",
            style="color: #000; text-decoration: underline"
          ) Change address
        .column.is-3
          .extra-info
            .user-location(v-show="!showDetails")
              img(
                v-if="builtAddress",
                :src="thumbImg || `https://maps.googleapis.com/maps/api/staticmap?&markers=${coordsFromMap.lat + ',' + coordsFromMap.lng}${mapPathString}&zoom=${mapsZoom['small']}&size=600x250&maptype=roadmap&key=${mapsKey}`"
              )
              .user-location-details
                fa-icon(icon="map-marker-alt")
                p.user-location-details-address {{ buildAddressWithName }}
            .product-details(v-show="showDetails")
              .product-details-backdrop
                .box(style="border-radius: 0")
                  .product-details-top
                    a.has-text-black.has-text-weight-normal(
                      @click.prevent="showDetails = false"
                    )
                      b X
                      span.additional-text CLOSE
                  h1.title FULL PRODUCT DETAILS
                  ul.product-details-perks.has-text-weight-normal.has-text-left(
                    v-if="productDetails"
                  )
                    li.product-details-perk(v-for="pD in productDetails")
                      fa-icon(icon="check-circle")
                      | {{ pD }}
                  p.has-text-weight-normal.has-text-left(v-else) No details available for this product
    .modal(v-bind:class="{ 'is-active': showModalSpecifyAddress }", v-bind:click-to-close="false", v-bind:no-close-on-backdrop="true" v-if="!showGeoModal")
      .modal-background
      .modal-card
        header.modal-card-head
          p.modal-card-title Please specify your address
        section.modal-card-body
          .add-address
            b(v-show="streetNumberError == true") Street number
            CustomInput(
              type="text",
              v-model="streetNumber",
              required,
              placeholder="Enter your street number",
              v-show="streetNumberError == true"
            )
            b(v-show="streetNameError == true") Street name
            CustomInput(
              type="text",
              v-model="streetName",
              required,
              placeholder="Enter your street name",
              v-show="streetNameError == true"
            )
            b(v-show="suburbError == true") Suburb
            CustomInput(
              type="text",
              v-model="suburb",
              required,
              placeholder="Enter your suburb",
              v-show="suburbError == true"
            )
            b(v-show="postalCodeError == true") Postal Code
            CustomInput(
              type="text",
              v-model="postalCode",
              required,
              placeholder="Enter your postal code",
              v-show="postalCodeError == true"
            )
            button.button.is-primary.product-details-button(
              :disabled="(!streetNumber && streetNumberError) || (!streetName && streetNameError) || (!suburb && suburbError) || (!postalCode && postalCodeError)",
              @click.prevent="specifyAddress"
            ) CONFIRM
            button.button.product-details-button(
              @click.prevent="returnToSearch"
            ) RETURN TO MAIN PAGE
    .modal(v-bind:class="{ 'is-active': showModal }" v-if="!showGeoModal")
      .modal-background
      .modal-card
        header.modal-card-head
          p.modal-card-title PLEASE CONFIRM YOUR ADDRESS BELOW
          button.delete(aria-label="close", @click.prevent="showModal = false")
        section.modal-card-body
          .add-address
            .columns(style="margin: 0")
              .column.is-6
                label
                  input(
                    type="radio",
                    name="type-of-address",
                    :value="'streetAddress'",
                    v-model="typeOfAddress"
                  )
                  span(style="font-size: 14px") &nbsp; Freestanding House/Dwelling
              .column.is-6
                label
                  input(
                    type="radio",
                    name="type-of-address",
                    :value="'unit'",
                    v-model="typeOfAddress"
                  )
                  span(style="font-size: 14px") &nbsp; Building/Complex
            b(v-show="typeOfAddress == 'unit'") Unit
            CustomInput(
              type="text",
              v-model="unitNumber",
              required,
              placeholder="Enter your unit / flat number",
              v-show="typeOfAddress == 'unit'"
            )
            p.help.is-danger(
              v-if="unitNumberError",
              v-show="typeOfAddress == 'unit'"
            ) {{ unitNumberError }}
            CustomInput(
              type="text",
              v-model="buildingName",
              placeholder="Enter building name (optional)",
              v-show="typeOfAddress == 'unit'"
            )
            CustomInput(
              type="text",
              disabled,
              v-model="buildAddressWithName",
              style="margin-top: 0.75rem"
            )

            button.button.is-primary.product-details-button(
              :disabled="!typeOfAddress || !unitNumber && typeOfAddress == 'unit'",
              @click.prevent="submitAddress"
            ) {{installType === "upgrade" ? "UPGRADE/DOWNGRADE" : "PROCEED TO SIGNUP"}}

            button.button.is-secondary.product-details-button(
              @click.prevent="$router.push({ name: 'home' })",
              style="margin-left: 10px"
            ) CHANGE ADDRESS
  Map(:address="builtAddress" v-if="showGeoModal && builtAddress")
</template>
<script>
import kmlParser from "../parseKml";

import _ from "lodash";

import CustomInput from "@/components/CustomInput.vue";
//import store from "@/store";
import Search from "@/components/Search.vue";
import Loader from "@/components/Loader.vue";
import brand from "@/brand";
import Map from "@/components/Map.vue";

export default {
  name: "ProductSelection",
  components: {
    Loader,
    Search,
    CustomInput,
    Map
  },
  props: ["address"],
  data() {
    return {
      loading: false,
      loaderMessage: null,
      loadeRetry: false,
      productType: null,
      selectedProductFull: null,
      name: null,
      zones: [],
      newAddress: null,
      errors: [],
      showDetails: false,
      showModal: false,
      showModalSpecifyAddress: false,
      selectedAddress: null,
      fullAddress: null,
      addAddress: false,
      typeOfAddress: null,
      streetNumber: null,
      streetName: null,
      suburb: null,
      postalCode: null,
      unitNumber: null,
      buildingName: null,
      streetNumberError: false,
      streetNameError: false,
      suburbError: false,
      postalCodeError: null,
      unitNumberError: null,
      zoneCoordsString: null,
      position: {
        lat: -33.9099856,
        lng: 18.41292670000007,
      },
      limitData: null,
      unitRegex: /^[a-zA-Z]?\d{1,4}[a-zA-Z]{0,2}$/,
      mapsZoom: {
        small: 16,
        big: 18
      },
      showGeoModal: false
    };
  },
  mounted() {
    this.loadProducts();
  },
  computed: {
    showLightspeedLogo() {
      const showLogo = {
        "gigalight"  : false,
        "ftta"       : false,
        "cybersmart" : true
      };

      return showLogo[brand.getBrand()];
    },

    activeProductsForRender() {
      const tempList = [];
      if (this.zone) {
        if (this.codeKey[1] == "null") {
          _.each(this.zone.promoCodes, (prod) => {
            _.each(prod.products, (val) => {
              tempList.push(val.main_product[0]);
            });
          });
        } else {
          _.each(this.zone.promoCodes[this.codeKey[1]].products, (val) => {
            tempList.push(val.main_product[0]);
          });
        }
      }
      return tempList;
    },
    mapPathString() {
      return this.zoneCoordsString? `&path=color:blue|fillcolor:blue|weight:2|${this.zoneCoordsString}` : "";
    },
    promoCodeId() {
      return this.$store.getters.getPromoCodeId;
    },
    installType() {
      return this.$store.getters.getInstallType;
    },
    provinces() {
      return this.$store.getters.getProvinces;
    },
    coordsFromMap() {
      return this.$store.getters.getCoordsFromMap;
    },
    productSection() {
      return (
        this.$store.getters.getProductSection ||
        (this.zones.length ? `${this.zones[0].provider_name}=null` : null)
      );
    },
    selectedProduct() {
      return this.$store.getters.getSelectedProduct;
    },
    codeKey() {
      return this.productSection ? this.productSection.split("=") : null;
    },
    zone() {
      return this.codeKey
        ? _.find(this.zones, { provider_name: this.codeKey[0] })
        : null;
    },
    activeProducts() {
      const tempList = {};
      if (this.zone) {
        if (this.codeKey[1] == "null") {
          _.each(this.zone.promoCodes, (prod) => {
            _.each(prod.products, (val) => {
              tempList["#"+val.promocodeproductid] = val.main_product[0];
              tempList["#"+val.promocodeproductid].promocodeproductid=val.promocodeproductid;
            });
          });
        } else {
          _.each(this.zone.promoCodes[this.codeKey[1]].products, (val) => {
            tempList["#"+val.promocodeproductid] = val.main_product[0];
            tempList["#"+val.promocodeproductid].promocodeproductid=val.promocodeproductid;
          });
        }
      }
      return tempList;
    },
    thumbImg() {
      return this.zone ? this.zone.image || null : null;
    },
    builtAddress() {
      return this.$store.getters.getBuiltAddress;
    },
    buildAddressWithName() {
      return this.name? this.name + ", " + this.$store.getters.getBuiltAddress : this.$store.getters.getBuiltAddress;
    },
    addresses() {
      return this.zone
        ? _.isArray(this.zone.addresses[0])
          ? this.zone.addresses[0]
          : this.zone.addresses
        : null;
    },
    addressCode() {
      return this.zone ? this.zone.code : null;
    },
    productIds() {
      return {
        promocodeproductid: this.activeProducts["#"+this.selectedProduct]
          ? this.activeProducts["#"+this.selectedProduct].promocodeproductid
          : null,
        productid: this.activeProducts["#"+this.selectedProduct]
          ? this.activeProducts["#"+this.selectedProduct].productid
          : null,
        promocodeid: this.getSelectedPromoCodeId(this.selectedProduct),
      };
    },
    mapsKey() {
      return process.env.VUE_APP_MAPS_API_KEY;
    },
    productDescription() {
      return this.activeProducts["#"+this.selectedProduct]
        ? this.activeProducts["#"+this.selectedProduct].description
        : null;
    },
    productDetails() {
      if (this.activeProducts["#"+this.selectedProduct]) {
        const { details } = this.activeProducts["#"+this.selectedProduct];
        return details.split(/\r?\n/g);
      }
      return null;
    },
  },
  watch: {
    addAddress(val) {
      if (val) this.selectedAddress = null;
    },
    selectedProduct: {
      immediate: true,
      handler(val) {
        this.setPromoCodeId(val);
      },
    },
    selectedProductFull(val) {
      if (val.description.indexOf("data only") >= 0) {
        this.setInstallType("data-only");
        this.productType = "data-only";
      } else if (val.description.indexOf("dsl") >= 0) {
        this.setInstallType("new");
        this.productType = "dsl";
      } else {
        this.productType = "fibre";
      }
    },
  },
  methods: {
    filter: _.filter,
    get: _.get,
    mapLoadError() {
      console.log('Too many points for gmap, skipping... ');
      this.zoneCoordsString = "";
    },
    productSelected() {
      this.$store.commit('setSelectedProduct', this.selectedProductFull.promocodeproductid);
    },
    loadRetry() {},
    navigate() {
      this.$router.push({
        name: "purchase",
        params: {
          product: this.selectedProduct,
        },
      });
    },
    setBuiltAddress() {
      let tempAddress;
      const baseAddress = this.newAddress || this.fullAddress;

      if (this.productSection && this.productSection.address) {
        tempAddress = this.productSection.address;
      } else if (baseAddress && baseAddress.route) {
        tempAddress = `${baseAddress.street_number || ""} ${
          baseAddress.route || baseAddress.street_name
        }, ${baseAddress.political}, ${baseAddress.locality}, ${
          baseAddress.administrative_area_level_1}, ${baseAddress.postal_code}`.trim();
      } else {
        tempAddress = this.address;
      }

      this.$store.commit(
        "setBuiltAddress",
        `${this.unitNumber ? `Unit ${this.unitNumber}, ` : ""}${tempAddress}`
      );
    },
    setInstallType(installType) {
      this.$store.commit("setInstallType", installType);
    },
    setAddressList(addresses) {
      this.$store.commit("setAddressList", addresses);
    },
    setFirstSelectedProduct() {
      let firstProd = _.find(this.activeProducts, "productid");
      if (firstProd) {
        this.selectedProductFull = firstProd;
        this.$store.commit("setSelectedProduct", firstProd.promocodeproductid);
      }
    },
    getSelectedPromoCodeId(selectedProduct) {
      let id = null;

      if (this.zone) {
        _.each(this.zone.promoCodes, (pC) => {
          _.each(pC.products, (product) => {
            if (product.promocodeproductid == selectedProduct) {
              id = pC.code;
              return false;
            }
          });
          if (id) {
            return false;
          }
        });
      }
      return id;
    },
    setPromoCodeId(selectedProduct) {
      this.$store.commit("setPromoCodeId", this.getSelectedPromoCodeId(selectedProduct));
    },
    checkAddress(addressComponents) {
      this.streetNumberError = !addressComponents["street_number"];
      this.streetNameError = !addressComponents["route"];
      this.suburbError = !addressComponents["political"];
      this.postalCodeError = !addressComponents["postal_code"];

      this.showModalSpecifyAddress = this.streetNumberError || this.streetAddressError || this.suburbError || this.postalCodeError ;

      console.log("street_number: ", addressComponents["street_number"], ", street_name: ", addressComponents["route"],
          ", suburb: ", addressComponents["political"], ", postal code: ", addressComponents["postal_code"]);
    },
    async loadProducts() {
      this.loading = true;
      if (this.$store.getters.getSpecifiedFullAddress) {
        this.fullAddress = this.$store.getters.getSpecifiedFullAddress;
      }

      if (this.address.trim().indexOf(" ") === -1) {
        const hm = new FormData();
        hm.set("zone", this.address);

        let response = null;
        try {
          response = await this.$http.post(
              `${process.env.VUE_APP_BACKEND_URL}feasibility/lookup_v2`,
              hm
          );
        } catch (e) {
          this.loading = false;
          this.$router.push({name: "home", params: {error: "Server error, please try again later"}});
          return;
        }

        if (response.data.kml) {
          this.zoneCoordsString = kmlParser.extractCoordFromKml(response.data.kml);
        }

        // build address from response
        this.name = response.data.name;
        const adBreak = response.data.address.split(',');
        this.fullAddress = {
          street_number: null,
          route: adBreak[0].trim(),
          political: adBreak[1].trim(),
          locality: response.data.city,
          administrative_area_level_2: response.data.city,
          administrative_area_level_1: response.data.province,
          country: "ZA",
          postal_code: response.data.postal_code,
        };

        this.zones.push(response.data);
        this.setFirstSelectedProduct();
        this.setBuiltAddress();
        this.loading = false;
      } else {
        await this.$gmapApiPromiseLazy();
        // eslint-disable-next-line
        const geocoder = new google.maps.Geocoder();
        console.log("Geocoder input: ", this.address);

        geocoder.geocode({ address: this.address }, async (results, status) => {
          if (status === "OK") {
            this.position.lat = results[0].geometry.location.lat();
            this.position.lng = results[0].geometry.location.lng();

            // set limit data for new address search
            this.limitData = {
              radius: process.env.VUE_APP_MAPS_LIMIT_RANGE || 5000,
              location: results[0].geometry.location,
            };

            console.log("Geocoder results: ", results);

            if (!this.$store.getters.getSpecifiedFullAddress) {
              const addressArray = {};

              results[0].address_components.forEach((component) => {
                addressArray[component.types[0]] = component.long_name;
                if (component.types[0] === "route" || component.types[0] === "street_name") {
                  addressArray["routeShort"] = component.short_name;
                }
              });

              this.fullAddress = addressArray;
              this.$store.commit("setSpecifiedFullAddress", this.fullAddress);
            }
            this.showGeoModal = true;
            document.querySelector('.product').classList.add('blur');
            document.querySelector('.cybersmart-footer').classList.add('blur');
            document.querySelector('.smart-bar').classList.add('blur');
            this.checkAddress(this.fullAddress);

            await this.getProducts();
          }
        });
      }
    },
    async specifyAddress() {
      if (this.streetNumber) {
          console.log("New street number: ", this.streetNumber);
          this.fullAddress["street_number"] = this.streetNumber;
      }
      if (this.streetName) {
          console.log("New street name: ", this.streetName);
          this.fullAddress["route"] = this.streetName;
      }
      if (this.suburb) {
          console.log("New suburb: ", this.suburb);
          this.fullAddress["political"] = this.suburb;
      }
      if (this.postalCode) {
        console.log("New postal code: ", this.postalCode);
        this.fullAddress["postal_code"] = this.postalCode;
      }

      this.$store.commit("setSpecifiedFullAddress", this.fullAddress);

      this.setBuiltAddress();

      this.showModalSpecifyAddress = false;
    },
    returnToSearch() {
      this.$router.push({
        name: "home"});
    },
    async submitAddress() {
      // check for existing address / zone
      const address = this.newAddress || this.fullAddress;

      // If unit address type is chosen check unit number format is valid
      if (this.typeOfAddress === "unit") {
        if (!this.unitNumber || !this.unitRegex.test(this.unitNumber.trim())) {
          this.unitNumberError = "Please input only unit number (e.g. \"221B\")";
          return;
        } else {
          this.unitNumberError = "";
        }
      } else {
        this.unitNumber = null;
      }

      this.setBuiltAddress();
      this.setAddressList(this.addresses);
      this.setPromoCodeId(this.selectedProduct);
      this.$store.commit("setZone", this.zone);
      let tempPosition = {};
      if (Object.keys(this.coordsFromMap).length) {
        tempPosition = this.coordsFromMap
      } else {
        tempPosition = this.position;
      }
      this.$store.commit("setPosition", tempPosition);

      this.$router.push({
        name: "purchase",
        params: {
          unitNumber: this.unitNumber,
          buildingName: this.buildingName,
          address: address,
          addressCode: this.addressCode,
          product: this.activeProducts["#"+this.selectedProduct],
          productIds: this.productIds,
          installType: this.installType,
        },
      });
    },
    adjustHeight() {
      const elFrom = document.querySelector(".modal-card-body");
      // set scroll position in px
      elFrom.scrollLeft = 0;
      elFrom.scrollTop = elFrom.offsetHeight;
    },
    async getProducts() {
      this.loading = true;
      let hm = new FormData();
      hm.set("latitude", this.coordsFromMap.lat || this.position.lat);
      hm.set("longitude", this.coordsFromMap.lng || this.position.lng);
      hm.set("address", this.address);

      hm.set("fullAddress", JSON.stringify(this.fullAddress));

      let response = null;
      try {
        response = await this.$http.post(
            `${process.env.VUE_APP_BACKEND_URL}feasibility/find_v2`,
            hm
        );
        this.zones = response.data;
        this.setFirstSelectedProduct();
        this.setBuiltAddress();

        this.zoneCoordsString = "";
        let kml = "";
        if (this.zones[0].preOrder) {
          kml = response.data[0].planned_kml
        } else {
          kml = response.data[0].kml;
        }

        if (kml) {
          this.zoneCoordsString = kmlParser.extractCoordFromKml(kml);
          this.mapsZoom['big'] = "15";
          this.mapsZoom['small'] = "15";
        }
      } catch (e) {
        this.$router.push({name: "home", params: {error: "Server error, please try again later"}});
        //TODO: print error
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style lang="scss">
@import "../vue-select-corrected";
@import "~bulma/sass/utilities/mixins";
@import "../styles/variables";


.product {
  input:disabled {
    color: #231f20 !important;
  }
  &.blur {
    filter: blur(3px);
  }

  .search-container {
    .location-search {
      box-shadow: -1px 1px 4px 1px rgba(80, 80, 80, 0.15);
      font-size: 1rem;
      height: 2.25em;
      line-height: 1.5;
      padding: 1.5rem 1rem;
    }
    p.control {
      display: none;
    }
  }

  .product-top {
    padding: 3rem;

    @include until($desktop) {
      padding: 0.5rem;
    }

    .product-info {
      margin-bottom: 2rem;

      .extra-info {
        min-width: 27vw;

        .product-details {
          .product-details-backdrop {
            background-color: transparent;
            margin: 0;
          }

          @include until($tablet) {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 400;
            margin: 0;

            .product-details-backdrop {
              height: 100%;
              width: 100%;
              background-color: #0f0f0fb0;
              padding: 1rem;
            }
          }

          .product-details-top {
            text-align: right;
            padding: 2rem 0;

            @include until($tablet) {
              padding-top: 0;
              font-size: 2rem;
              .additional-text {
                display: none;
              }
              .title {
                font-size: 1.25rem;
              }
            }
          }

          .product-details-perks {
            margin: 2rem;

            svg {
              color: #01a5e8;
              margin-left: -2rem;
              margin-right: 1rem;
            }
          }
        }

        .user-location {
          .user-location-container {
            position: relative;
            height: 250px;
            background: no-repeat center;
            background-size: cover;

            .image {
              width: 100%;
              height: 100%;
              margin: 0;
              padding: 0;
              border: none;
              background-color: lighten($secondary-colour, 20%);
            }

            .user-location-enlarge {
              position: absolute;
              display: flex;
              right: 0;
              top: 0;
              justify-content: center;
              align-items: center;
              width: 3rem;
              height: 3rem;
              background-color: $secondary-colour;
              color: #fff;
            }
          }

          .user-location-details {
            display: flex;
            background-color: $secondary-colour;
            padding: 1rem;
            color: #fff;
            flex: 1;
            align-items: center;

            .user-location-details-address {
              padding: 0.5rem 1rem;
              align-self: center;
              text-align: left;
            }
          }
        }
      }

      .product-type {
        @include until($desktop) {
          background-color: #f4f4f4;
        }
        @include from($desktop) {
          max-width: 500px;
        }

        .product-type-option {
          display: block;
          cursor: pointer;

          input {
            display: none;

            &:checked + .product-type-label {
              background-color: $secondary-colour;
              font-weight: bold;
              color: #fff;
            }
          }

          .product-type-label {
            display: flex;
            align-content: center;
            padding: 1rem;
            @include from($desktop) {
              font-weight: normal;
            }

            &:hover {
              background-color: lighten($secondary-colour, 80%);
            }
          }

          &::after {
            display: block;
            content: attr(data-name);
            font-weight: bold;
            height: 1px;
            color: transparent;
            overflow: hidden;
            visibility: hidden;
            padding: 0 5rem;
          }
        }
      }

      .product-details {
        border-radius: 0;
        flex: 1;

        .product-address-title {
          letter-spacing: 2px;
          font-size: 1.75rem;
          color: $secondary-colour;
          font-weight: bolder;
          margin-bottom: 3rem;
        }

        .product-details-buttons {
          display: grid;
          grid-gap: 1rem;
          @include from($desktop) {
            grid-template-columns: 1fr 1fr;
          }

          .product-details-button {
            border-radius: 0;
            padding: 1rem;
            height: auto;
          }

          .is-primary {
            background-color: #0193cf;
            border-color: transparent;
            color: #fff;
            font-size: 1rem;
            font-weight: bold;
            line-height: 1.5;
          }
        }

        .product-details-image-ad {
          margin-top: 1rem;
          width: 30%;
          @include until($desktop) {
            width: 50%;
          }
        }

        .info-link {
          text-decoration: underline;
          color: #000;
        }

        .product-details-install-time {
          position: relative;

          .time-info {
            margin-left: 5px;
            color: #01a5e8;
            cursor: pointer;

            &:hover,
            &:focus {
              .popover-info {
                opacity: 1;
              }
            }

            .popover-info {
              opacity: 0;
              display: flex;
              position: absolute;
              flex-direction: column;
              top: 100%;
              transition: opacity 250ms;

              .arrow {
                width: 0;
                height: 0;
                border: solid 20px transparent;
                border-top: none;
                border-bottom-color: #01a5e8;
                align-self: center;
              }

              .text {
                background-color: #01a5e8;
                padding: 1rem;
                color: #fff;
                font-size: 0.75rem;
              }
            }
          }
        }
      }
    }

    .product-user-location-map {
      width: 100%;
      margin: 2rem auto 0;
    }
  }

  .modal {
    .modal-card {
      @include until($desktop) {
        min-height: 65vh;
        width: 90vw;
      }
      @include from($desktop) {
        min-height: 50vh;
      }
    }
    .custom-input {
      margin-bottom: 1rem;
    }
    .modal-card-head {
      padding-left: 40px;
      text-align: left;
      .modal-card-title {
        width: 80%;
      }
    }
    .modal-card-body {
      padding-left: 40px;
      text-align: left;

      .product-details-button {
        margin-top: 1rem;
        border-radius: 0;
        padding: 1rem;
        height: auto;
        margin-right: 15px;
      }

      .add-address-button {
        margin-top: 1rem;
      }
    }
  }
}
</style>
